import React from 'react';
import { InputProps } from '../../../types';

export const BooleanInput: React.FC<InputProps<boolean>> = ({ 
  value, 
  onChange, 
  readOnly 
}) => {
  return (
    <div className={`flex items-center space-x-2 ${readOnly ? 'opacity-70' : ''}`}>
      <button
        onClick={() => !readOnly && onChange(!value)}
        disabled={readOnly}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          value ? 'bg-teal-600' : 'bg-slate-200'
        } ${readOnly ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform shadow-sm ${
            value ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className="text-sm text-slate-600 font-medium">{value ? 'Yes' : 'No'}</span>
    </div>
  );
};